import classNames from 'classnames'

export default function FormSubmit ({ className, value, loadingValue, loading = false, onClick }) {
  return (
    <input
      className={classNames(
        "button primary-button",
        className
      )}
      type="submit"
      value={loading ? loadingValue : value}
      disabled={loading}
      onClick={onClick}
    />
  )
}
